import alt from "../alt";
import indexBy from "lodash/keyBy";
import PassSubscriptionUtil from "../utils/PassSubscriptionUtil";
import PassSubscriptionActions from "../actions/PassSubscriptionActions";
import PersonStore from "./PersonStore";

class PassSubscriptionStore {
  constructor() {
    this.bindActions(PassSubscriptionActions);

    this.state = {
      passSubscriptions: {},
      hasUpdatedAll: false
    };

    this.exportPublicMethods({
      getPassSubscriptionById: this.getPassSubscriptionById.bind(this)
    });
  }

  getPassSubscriptionById(id) {
    return this.state.passSubscriptions[id];
  }

  onFetchAll() {
    PassSubscriptionUtil.fetchAll(PersonStore.getState().token)
      .then(data => {
        PassSubscriptionActions.updatePassSubscriptions(indexBy(data, "id"));
      })
      .catch(PassSubscriptionActions.fetchFailed);
  }

  onFetchOne(id) {
    PassSubscriptionUtil.fetchOne(PersonStore.getState().token, id)
      .then(data => {
        PassSubscriptionActions.updatePassSubscription(id, data);
      })
      .catch(PassSubscriptionActions.fetchFailed);
  }

  onUpdatePassSubscriptions(passSubscriptions) {
    this.setState({ passSubscriptions, hasUpdatedAll: true });
  }

  onUpdatePassSubscription(data) {
    this.state.passSubscriptions[data.id] = data.passSubscription;
    this.setState(this.state);
  }

  onEditPassSubscription(newData) {
    PassSubscriptionUtil.edit(newData.id, newData.values)
      .then(data => {
        PassSubscriptionActions.updatePassSubscription(newData.id, data);
      })
      .catch(PassSubscriptionActions.editFailed);
  }

  onEditFailed(e) {
    window.alert(
      `Sorry, something went wrong editing your subscription: ${e.message}`
    );
    throw e;
  }

  onFetchFailed(e) {
    throw e;
  }
}

export default alt.createStore(PassSubscriptionStore, "PassSubscriptionStore");



// WEBPACK FOOTER //
// ./src/app/stores/PassSubscriptionStore.js